import { Link } from "react-router-dom";
import { ArrowRight, Compass, Handshake, Users } from "lucide-react";
import { Reveal, Eyebrow, MaskedLines } from "@/components/Reveal";
import { Marquee } from "@/components/Marquee";

const VALUES = [
  {
    icon: Compass,
    title: "Strategia prima delle telecamere",
    desc: "Ogni progetto nasce da un audit dei contenuti e da obiettivi di business misurabili, non da estetica fine a se stessa.",
  },
  {
    icon: Handshake,
    title: "Un solo referente senior",
    desc: "Niente catene di mail con agenzie di intermediazione: parli direttamente con chi scrive, gira e monta il tuo video.",
  },
  {
    icon: Users,
    title: "Pensata per i team marketing",
    desc: "Social media manager, e-commerce e founder: formati e tagli pronti per ogni piattaforma e campagna.",
  },
];

export const ChiSiamo = () => (
  <div className="pt-28 lg:pt-36 pb-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <Eyebrow>Chi siamo</Eyebrow>
      </Reveal>
      <MaskedLines
        as="h1"
        delay={0.1}
        className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white leading-[1.06] max-w-4xl"
        lines={[
          "Uno studio costruito",
          "per i social",
          <span key="c" className="text-gradient-blue">che hanno qualcosa da vendere.</span>,
        ]}
      />

      <div className="mt-16 grid gap-10 lg:grid-cols-[1.2fr_1fr] items-start">
        <Reveal className="overflow-hidden rounded-3xl border border-lineblue">
          <img
            src="https://images.pexels.com/photos/6476785/pexels-photo-6476785.jpeg?auto=compress&cs=tinysrgb&w=1400"
            alt="Team social media al lavoro nella produzione di contenuti video"
            className="aspect-[16/10] w-full object-cover"
          />
        </Reveal>
        <Reveal delay={0.15} className="flex flex-col justify-center">
          <p className="text-lg leading-relaxed text-slate-300">
            CINEBLUE Executive è lo studio di video production e advertising
            dedicato ai social: TikTok, Instagram e Facebook. Trasformiamo
            prodotti, servizi e momenti del tuo brand in video verticali che
            fermano lo scroll e convertono.
          </p>
          <p className="mt-6 text-base leading-relaxed text-slate-400">
            Un metodo in quattro fasi — audit, hook, produzione, distribuzione —
            e un catalogo trasparente di dieci pacchetti a partire da 79,99 €,
            per iniziare senza preventivi interminabili.
          </p>
          <Link
            to="/pacchetti"
            data-testid="about-cta-packages"
            className="group mt-10 inline-flex w-fit items-center gap-3 rounded-full bg-electric px-7 py-4 text-sm font-bold text-ink transition-all duration-300 hover:bg-glow hover:shadow-[0_0_40px_rgba(56,189,248,0.35)]"
          >
            Scopri i pacchetti
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>
    </div>

    <div className="mt-24">
      <Marquee
        items={[
          "TikTok Ads",
          "Instagram Reels",
          "Facebook Ads",
          "UGC Creation",
          "Video Prodotto",
          "Spark Ads",
          "Meta Ads Manager",
        ]}
      />
    </div>

    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-24">
      <Reveal>
        <Eyebrow>I nostri principi</Eyebrow>
        <h2 className="mt-4 font-display text-3xl sm:text-4xl font-semibold tracking-tight text-white">
          Tre regole, zero dispersione.
        </h2>
      </Reveal>
      <div className="mt-12 grid gap-6 md:grid-cols-3">
        {VALUES.map((v, i) => (
          <Reveal
            key={v.title}
            delay={i * 0.1}
            className="group rounded-2xl border border-lineblue bg-panel p-8 transition-all duration-500 hover:border-glow hover:bg-panelhover"
          >
            <v.icon className="h-8 w-8 text-electric" />
            <h3 className="mt-6 font-display text-xl font-semibold text-white">{v.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-400">{v.desc}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </div>
);

export default ChiSiamo;
